import React from "react";
import { Skeleton as MuiSkeleton, SkeletonProps, Box } from "@mui/material";

const Skeleton: React.FC<SkeletonProps> = (props) => <MuiSkeleton {...props} />;

export interface SkeletonListItemProps {
  avatarSize?: number;
  lines?: number;
}

export const SkeletonListItem: React.FC<SkeletonListItemProps> = ({
  avatarSize = 40,
  lines = 2,
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 1 }}>
    <MuiSkeleton variant="circular" width={avatarSize} height={avatarSize} />
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <MuiSkeleton
          key={i}
          variant="text"
          width={i === lines - 1 ? "40%" : "70%"}
        />
      ))}
    </Box>
  </Box>
);

export default Skeleton;
